import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { CircularProgress, Stack } from '@mui/material'
import { useAuth } from '../providers/auth/AuthProvider'

interface ProtectedRouteProps {
  children: React.ReactElement
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { loading, isAuthenticated } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <Stack alignItems="center" justifyContent="center" minHeight="60vh">
        <CircularProgress />
      </Stack>
    )
  }

  if (!isAuthenticated()) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />
  }

  return children
}

export default ProtectedRoute
